<template>
  <el-header height="60px" class="header-container">
    <h1>元气管理系统</h1>
    <div class="header-right">
      <el-button
        type="danger"
        size="small"
        icon="el-icon-switch-button"
        @click="$emit('logout')"
      >
        退出登录
      </el-button>
    </div>
  </el-header>
</template>

<script>
export default {
  name: 'AdminHeader'
};
</script>

<style scoped>
.header-container {
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  flex-shrink: 0;
}

.el-header h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

.header-right {
  display: flex;
  align-items: center;
}
</style>

